(function() { window.GUID_06534b56_bccb_4a8f_b8f7_3a998ffbd479 = { getGuid: function() { return "06534b56-bccb-4a8f-b8f7-3a998ffbd479"; } }; })();
var CS;
(function (CS) {
    class DropDown {
        constructor(dropDown) {
            this.ForcedSelectedValue = null;
            this.Refresh = function () {
                var me = this;
                var data = CS.PrepareDataToSendGlobal(me);
                CompuSport.Ajax.Get(me.RefreshUrl, data, function (result) {
                    //var $result = $(result);
                    //var csDropDownPart = $('.CSDropDown', $result);
                    //me.DropDown.replaceWith(csDropDownPart);
                    //me.DropDown = csDropDownPart;
                    //me.PrepareOnChange();
                    //me.DropDown.trigger('change');
                    ////me.DropDown = $(resizeBy)
                    ////var newDropDown =  new CS.DropDown($('.CSDropDown', $result));
                    ////newDropDown.DropDown.trigger('change');
                    if (result != null) {
                        FillDropDownFromJson(me.DropDown, result, me.ForcedSelectedValue);
                        me.DropDown.trigger('change');
                        me.ForcedSelectedValue = null;
                    }
                });
            };
            /*this.DropDownId = dropDown[0].id;
            this.DropDown = dropDown;
            this.DropDown.data('context', this);
            this.LastSelectedText = $('option:selected', this.DropDown).text();
            this.LastSelectedValue = this.val();

            if (dropDown.data('refreshelementids') != null) {
                this.RefreshElementIds = dropDown.data('refreshelementids').split(',');
                this.RefreshUrl = dropDown.data('refreshurl');
                this.BindToRefreshElements();
            }
            if (dropDown.data('keepdropdownstate') != null) {
                this.KeepDropDownState = dropDown.data('keepdropdownstate');
            }
            if (this.RefreshUrl != null && this.RefreshUrl != "") {
                this.RefreshUrl += CSParameters.SportEventId;
            }

            this.PrepareOnChange();*/
        }
        val(newVal, withoutEvent) {
            if (newVal != null) {
                this.DropDown.val(newVal);
                if (!withoutEvent) {
                    this.DropDown.trigger('change');
                }
                return this.DropDown.val();
            }
            else {
                return this.DropDown.val();
            }
        }
        ChangeStyle() {
            var me = this;
            var selectBoxContainer = $('<div>', {
                width: this.DropDown.outerWidth(),
                height: this.DropDown.outerHeight(),
                "class": 'tzSelect',
                html: '<div class="selectBox"><div class="TextSelection"></div><div class="ArrowSelection"></div></div>'
            });
            var options = $('option', this.DropDown);
            var selectBox = selectBoxContainer.find('.selectBox');
            var dropDown = $('<ul>', { "class": 'dropDown' });
            var actualValue = this.DropDown.val();
            $.each(options, function (index, element) {
                var option = $(element);
                if (option.val() == actualValue) {
                    $('.TextSelection', selectBox).html(option.text());
                }
                var htmlContext = $(this).data('htmlcontent');
                if (htmlContext == null) {
                    htmlContext = $(this).text();
                }
                var li = $('<li>', {
                    html: htmlContext
                });
                li.data('optiontext', option.text());
                li.data('optionvalue', option.val());
                li.on('click', function () {
                    $('.TextSelection', selectBox).html(option.text());
                    me.DropDown.val($(this).data('optionvalue'));
                    me.DropDown.trigger('change');
                    dropDown.trigger('hide');
                    return false;
                });
                dropDown.append(li);
            });
            selectBoxContainer.append(dropDown.hide());
            this.DropDown.hide().after(selectBoxContainer);
            dropDown.on('show', function () {
                $('.ui-dialog-content').css('overflow', 'visible');
                if (dropDown.is(':animated')) {
                    return false;
                }
                selectBox.addClass('expanded');
                dropDown.slideDown();
            }).on('hide', function () {
                if (dropDown.is(':animated')) {
                    return false;
                }
                selectBox.removeClass('expanded');
                dropDown.slideUp();
                $('.ui-dialog-content').css('overflow', 'auto');
            }).on('toggle', function () {
                if (selectBox.hasClass('expanded')) {
                    dropDown.trigger('hide');
                }
                else {
                    dropDown.trigger('show');
                }
            });
            selectBox.on('click', function () {
                dropDown.trigger('toggle');
                return false;
            });
            // If we click anywhere on the page, while the
            // dropdown is shown, it is going to be hidden:
            CS.doc.on('click.dropdown', function () {
                dropDown.trigger('hide');
            });
        }
        PrepareOnChange() {
            var me = this;
            me.DropDown.off('change.' + me.DropDownId);
            me.DropDown.on('change.' + me.DropDownId, function () {
                if (CSParameters.IsConnected && me.KeepDropDownState == "True") {
                    var data = {
                        keyName: me.DropDownId,
                        value: me.DropDown.val()
                    };
                    CompuSport.Ajax.Post(CSParameters.ControllerUrl + 'SaveUserData/' + CSParameters.SportEventId, data, function (result) {
                    });
                }
                if (me.SelectionChange != null) {
                    me.SelectionChange.call(me);
                }
                me.DropDown.trigger("CSChange", me);
                me.LastSelectedText = $('option:selected', me.DropDown).text();
                me.LastSelectedValue = me.val();
            });
        }
        BindToRefreshElements() {
            var me = this;
            var lastIndex = me.RefreshElementIds.length - 1;
            $.each(me.RefreshElementIds, function (index, id) {
                if (!String.isNullOrEmpty(id)) {
                    var controller = $('#' + id);
                    if (controller.length == 0) {
                        controller = $('[name="' + id + '"]');
                    }
                    if (controller.length > 0) {
                        var eventWithNamespace = 'change.' + me.DropDownId;
                        if (index == lastIndex) {
                            controller.off(eventWithNamespace);
                            controller.on(eventWithNamespace, function (sender) {
                                me.Refresh();
                            });
                        }
                    }
                }
            });
        }
    }
    CS.DropDown = DropDown;
})(CS || (CS = {}));
function FillDropDownFromJson(dropDown, json, forceSelectedValue) {
    dropDown.empty();
    if (json.length > 0) {
        var selectedValue;
        $(json).each(function () {
            if (this.Selected && forceSelectedValue == null) {
                selectedValue = this.Value;
            }
            else if (forceSelectedValue == this.Value) {
                selectedValue = this.Value;
            }
            dropDown.append($('<option/>', {
                value: this.Value
            }).html(this.Text));
        });
        if (selectedValue == null) {
            selectedValue = $(json).first()[0].Value;
        }
        if (selectedValue != null) {
            dropDown.val(selectedValue);
        }
        else {
            dropDown.val("");
        }
    }
}
/*
(function ($) {
    $.fn.CSDropDown = function () {
        this.each(function () {
            var dropdown = new CS.DropDown($(this));
            //Donne access au dropDown de n'importe quels scripts.
            eval('document.' + dropdown.DropDownId + '=dropdown;');
        });
    };
})(jQuery);


var CS = CS || {};

CS.DropDown = function (me) {

    this.DropDownId = me[0].id;
    this.DropDown = me;
    this.ForcedSelectedValue = null;

    this.val = function (newVal, withoutEvent) {
        if (newVal != null) {
            this.DropDown.val(newVal);
            if (!withoutEvent)
                this.DropDown.trigger('change');
            return this.DropDown.val();
        }
        else {
            return this.DropDown.val();
        }
    };
    //this.ChangeStyle();

    this.LastSelectedText = $('option:selected', this.DropDown).text();
    this.LastSelectedValue = this.val();

    if (me.data('refreshelementids') != null) {
        this.RefreshElementIds = me.data('refreshelementids').split(',');
        this.RefreshUrl = me.data('refreshurl');
        this.BindToRefreshElements();
    }
    if (me.data('keepdropdownstate') != null) {
        this.KeepDropDownState = me.data('keepdropdownstate');
    }
    if (this.RefreshUrl != null && this.RefreshUrl != "") {
        this.RefreshUrl += CSParameters.SportEventId;
    }

    this.PrepareOnChange();
};

CS.DropDown.prototype = function () {

    var ChangeStyle = function () {
        var me = this;
        var selectBoxContainer = $('<div>', {
            width: this.DropDown.outerWidth(),
            height: this.DropDown.outerHeight(),
            "class": 'tzSelect',
            html: '<div class="selectBox"><div class="TextSelection"></div><div class="ArrowSelection"></div></div>'
        });


        var options = $('option', this.DropDown);
        var selectBox = selectBoxContainer.find('.selectBox');
        var dropDown = $('<ul>', { "class": 'dropDown' });

        var actualValue = this.DropDown.val();


        $.each(options, function (index, element) {

            var option = $(element);

            if (option.val() == actualValue) {
                $('.TextSelection', selectBox).html(option.text());
            }

            var htmlContext = $(this).data('htmlcontent');
            if (htmlContext == null) {
                htmlContext = $(this).text();
            }
            var li = $('<li>', {
                html: htmlContext
            });
            li.data('optiontext', option.text());
            li.data('optionvalue', option.val());

            li.click(function () {

                $('.TextSelection', selectBox).html(option.text());
                me.DropDown.val($(this).data('optionvalue'));
                me.DropDown.trigger('change');
                dropDown.trigger('hide');

                return false;
            });

            dropDown.append(li);
        });

        selectBoxContainer.append(dropDown.hide());
        this.DropDown.hide().after(selectBoxContainer);

        dropDown.bind('show', function () {
            $('.ui-dialog-content').css('overflow', 'visible');

            if (dropDown.is(':animated')) {
                return false;
            }

            selectBox.addClass('expanded');
            dropDown.slideDown();

        }).bind('hide', function () {

            if (dropDown.is(':animated')) {
                return false;
            }

            selectBox.removeClass('expanded');
            dropDown.slideUp();

            $('.ui-dialog-content').css('overflow', 'auto');
        }).bind('toggle', function () {
            if (selectBox.hasClass('expanded')) {
                dropDown.trigger('hide');
            }
            else dropDown.trigger('show');
        });

        selectBox.click(function () {
            dropDown.trigger('toggle');
            return false;
        });

        // If we click anywhere on the page, while the
        // dropdown is shown, it is going to be hidden:

        CS.doc.on('click.dropdown', function () {
            dropDown.trigger('hide');
        });

    },
    PrepareOnChange = function () {
        var me = this;

        me.DropDown.off('change.' + me.DropDownId);
        me.DropDown.on('change.' + me.DropDownId, function () {

            if (CSParameters.IsConnected && me.KeepDropDownState == "True") {

                var data = {};
                data.keyName = me.DropDownId;
                data.value = me.DropDown.val();

                $.ajaxAntiForgery({
                    cache: false,
                    type: "POST",
                    //dataType: "json",
                    url: CSParameters.ControllerUrl + 'SaveUserData/' + CSParameters.SportEventId,
                    data: data,
                    success: function (result) {
                    }
                });
            }

            if (me.SelectionChange != null)
                me.SelectionChange.call(me);

            me.DropDown.trigger("CSChange", me);

            me.LastSelectedText = $('option:selected', me.DropDown).text();
            me.LastSelectedValue = me.val();
        });

    },
    Refresh = function () {
        var me = this;

        var data = CS.PrepareDataToSendGlobal(me);

        $.ajax({
            cache: false,
            dataType: "json",
            url: me.RefreshUrl,
            data: data,
            success: function (result) {

                //var $result = $(result);

                //var csDropDownPart = $('.CSDropDown', $result);

                //me.DropDown.replaceWith(csDropDownPart);
                //me.DropDown = csDropDownPart;
                //me.PrepareOnChange();
                //me.DropDown.trigger('change');

                ////me.DropDown = $(resizeBy)
                ////var newDropDown =  new CS.DropDown($('.CSDropDown', $result));
 
                ////newDropDown.DropDown.trigger('change');

                if (result != null) {
                    FillDropDownFromJson(me.DropDown, result, me.ForcedSelectedValue);
                    me.DropDown.trigger('change');
                    me.ForcedSelectedValue = null;
                }
            }
        });
    },
    BindToRefreshElements = function () {
        var me = this;
        var lastIndex = me.RefreshElementIds.length - 1;

        $.each(me.RefreshElementIds, function (index, id) {

            var controller = $('#' + id);
            if (controller.length == 0)
                controller = $('[name="' + id + '"]');

            if (controller.length > 0) {
                var eventWithNamespace = 'change.' + me.DropDownId;

                if (index == lastIndex) {
                    controller.unbind(eventWithNamespace);
                    controller.bind(eventWithNamespace, function (sender) {
                        me.Refresh();
                    });
                }
            }
        });


    };
    return {
        ChangeStyle: ChangeStyle,
        PrepareOnChange: PrepareOnChange,
        BindToRefreshElements: BindToRefreshElements,
        Refresh: Refresh
    };

}();
*/

//# sourceMappingURL=cs.dropdown.js.map
